import { useMemo, useState } from 'react';

const buildingTabs = [
  { id: 'akasaka', label: '赤坂テラス' },
  { id: 'aoyama', label: '南青山タワー' },
  { id: 'shinjuku', label: '新宿センタービル' },
];

const inspectionData = {
  akasaka: {
    next: '2026/01/18 消防設備点検',
    vendor: 'アイ防災',
    rows: [
      { name: '消防設備点検', date: '2026/01/18', status: '予定', note: '写真準備' },
      { name: '貯水槽清掃', date: '2026/02/02', status: '依頼中', note: '見積待ち' },
      { name: 'エレベーター点検', date: '2026/02/10', status: '完了', note: '報告書あり' },
    ],
  },
  aoyama: {
    next: '2026/01/12 空調設備点検',
    vendor: '光電工業',
    rows: [
      { name: '空調設備点検', date: '2026/01/12', status: '予定', note: '法令' },
      { name: '非常用発電機点検', date: '2026/01/28', status: '調整中', note: '日程調整' },
    ],
  },
  shinjuku: {
    next: '2026/01/20 防火扉点検',
    vendor: '三星サービス',
    rows: [
      { name: '防火扉点検', date: '2026/01/20', status: '予定', note: '写真未整理' },
      { name: '給排水設備点検', date: '2026/02/05', status: '依頼中', note: '発注作成中' },
    ],
  },
};

export function BuildingMaintenanceInspectionsPage() {
  const [activeBuilding, setActiveBuilding] = useState(buildingTabs[0].id);
  const current = inspectionData[activeBuilding as keyof typeof inspectionData];

  const summary = useMemo(
    () => [
      { label: '法定点検', value: '32件', note: '今月 12件' },
      { label: '未完了', value: '7件', note: '写真未整理 3件' },
      { label: '見積・発注連動', value: '5件', note: '見積待ち 2件' },
    ],
    []
  );

  return (
    <div className="bm2-grid" style={{ gap: '22px' }}>
      <section>
        <h2 className="bm2-section-title" data-testid="bm-inspections-title">法定点検をビルごとに管理</h2>
        <div className="bm2-tabs">
          {buildingTabs.map((building) => (
            <button
              key={building.id}
              type="button"
              className={`bm2-tab ${activeBuilding === building.id ? 'active' : ''}`}
              onClick={() => setActiveBuilding(building.id)}
              data-testid={`bm-inspections-tab-${building.id}`}
            >
              {building.label}
            </button>
          ))}
        </div>
      </section>

      <section className="bm2-grid cols-3">
        {summary.map((item) => (
          <div key={item.label} className="bm2-card">
            <small>{item.label}</small>
            <div className="bm2-kpi">
              <strong>{item.value}</strong>
              <span className="bm2-pill">集計</span>
            </div>
            <div className="bm2-highlight">{item.note}</div>
          </div>
        ))}
      </section>

      <section className="bm2-split">
        <div className="bm2-card">
          <h3>{buildingTabs.find((b) => b.id === activeBuilding)?.label} の法定点検</h3>
          <p className="bm2-highlight">
            次回予定: {current.next} / 担当業者: {current.vendor}
          </p>
          <div>
            {current.rows.map((row) => (
              <div key={`${row.name}-${row.date}`} className="bm2-inspection-row">
                <div>{row.name}</div>
                <div>
                  {row.date} <span className="bm2-tag">{row.status}</span>
                </div>
                <div>{row.note}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="bm2-grid" style={{ gap: '16px' }}>
          <div className="bm2-card">
            <h3>関連資料</h3>
            <ul className="bm2-list">
              <li>
                <div>点検報告書.pdf</div>
                <span className="bm2-tag">閲覧</span>
              </li>
              <li>
                <div>消防設備 写真 6枚</div>
                <span className="bm2-tag">写真</span>
              </li>
              <li>
                <div>改善指示書.pdf</div>
                <span className="bm2-tag">共有</span>
              </li>
            </ul>
          </div>
          <div className="bm2-card">
            <h3>点検→見積・発注 連動</h3>
            <p className="bm2-highlight">点検で指摘された内容を見積・発注に自動連携</p>
            <ul className="bm2-list">
              <li>
                <div>非常灯交換 / 見積待ち</div>
                <span className="bm2-pill warn">見積中</span>
              </li>
              <li>
                <div>防火扉調整 / 依頼済み</div>
                <span className="bm2-pill ok">進行</span>
              </li>
            </ul>
            <button type="button" className="bm2-button primary" style={{ marginTop: '12px' }}>
              発注管理へ連動
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
